import * as React from 'react'
import Background from '../background/Background'
import { IWish, IVoteTag } from 'types'
import { wishCategories } from '../wishes/wishes'
import { RouteComponentProps } from 'react-router'
import Title from '../titlte/Title'
import WishButton from '../buttons/WishButton'
import { getVoteOptions } from '../votes/votes'
import VoteTag from '../votes/VoteTag'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { RematchRootState } from '@rematch/core'
import { models } from '../../store'
import { addWish } from '../../db'

interface WishProps extends ReturnType<typeof mapStateToProps> {}

const getWishConfigForType = (type: IWish['type']): IWish | undefined => {
  return wishCategories.find(wish => wish.type === type)
}

interface WishState {
  selectedTags: IVoteTag[]
}

class Wish extends React.Component<WishProps & RouteComponentProps<{ type: string }>, WishState> {
  constructor(props: WishProps & RouteComponentProps<{ type: string }>) {
    super(props)
    this.state = {
      selectedTags: [],
    }
  }

  setVoteTagOption = (voteTag: IVoteTag) => {
    if (this.state.selectedTags.some(tag => tag.type === voteTag.type)) {
      this.setState({
        selectedTags: this.state.selectedTags.filter(tag => tag.type !== voteTag.type),
      })
    } else {
      this.setState({
        selectedTags: [...this.state.selectedTags, voteTag],
      })
    }
  }

  render() {
    const {
      match: { params },
    } = this.props

    const wish = getWishConfigForType(params.type as IWish['type'])

    if (!wish) {
      return null
    }

    return (
      <div style={{ height: '100vh', overflow: 'hidden' }}>
        <Background style={{ padding: '16px 16px 0 16px' }}>
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >
            <Title style={{ color: 'white' }} size="40px">
              {wish.name} - Wofür?
            </Title>
            <div style={{ overflow: 'auto' }}>
              {getVoteOptions(wish.type).map(voteTag => (
                <VoteTag
                  tag={voteTag}
                  onSelect={e => this.setVoteTagOption(e)}
                  selected={this.state.selectedTags.some(tag => tag.type === voteTag.type)}
                />
              ))}
            </div>
            <div
              style={{
                marginTop: 'auto',
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                marginBottom: '20px',
                height: '76px',
                minHeight: '76px',
              }}
            >
              <Link to={`/category/${wish.type}/map/`}>
                <WishButton
                  onClick={() => {
                    if (this.props.currentLocation != null) {
                      addWish({
                        id: '',
                        user: 'anonymous',
                        createdAt: Date.now(),
                        type: wish.type,
                        lat: this.props.currentLocation.lat,
                        lng: this.props.currentLocation.lng,
                      })
                    }
                  }}
                  style={{
                    height: '56px',
                    minHeight: '56px',
                    backgroundColor: '#FFE066',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginTop: '20px',
                  }}
                >
                  Wunsch abschicken
                </WishButton>
              </Link>
            </div>
          </div>
        </Background>
      </div>
    )
  }
}

const mapStateToProps = (state: RematchRootState<models>) => ({
  currentLocation: state.wishes.currentLocation,
})
export default connect(mapStateToProps)(Wish)



// WEBPACK FOOTER //
// ./src/components/routes/Wish.tsx